import React from 'react';
import './RadialInfo.css';

const services = [
  { label: 'Industrial/Domestic Softener-FRP/MS', className: 'blue', url: '/IDS' },
  { label: 'FRP-Pressure Sand Filter', className: 'red', url: '/FRP' },
  { label: 'Sewage Treatment Plant', className: 'yellow', url: '/STP' },
  { label: 'Ultra Filtration ', className: 'gray', url: '/UF' },
  { label: 'Effluent Treatment Plant', className: 'cyan', url: '/ETP' },
  { label: 'Pressure and Filter & Activated Carbon Filter', className: 'darkgray', url: '/PSF' },
  { label: 'Skid Mounted RO System', className: 'orange', url: '/RO' },
  { label: 'Water Treatment Plant', className: 'pink', url: '/WTP' },
];

export default function RadialInfo() {
  const [radiusX, setRadiusX] = React.useState(380);
const [radiusY, setRadiusY] = React.useState(200);

React.useEffect(() => {
  const handleResize = () => {
    const w = window.innerWidth;
    if (w < 480) {
      setRadiusX(240);
      setRadiusY(160);
    } else if (w < 768) {
      setRadiusX(200);
      setRadiusY(140);
    } else {
      setRadiusX(380);
      setRadiusY(200);
    }
  };
  handleResize();
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  return (
    <div className="infographic-container">
      <div className="center-circle">
        <span className="center-label">Our Services</span>
      </div>

      {services.map((service, index) => {
        const angle = (2 * Math.PI / services.length) * index; // radians
        const x = Math.cos(angle) * radiusX;
        const y = Math.sin(angle) * radiusY;

        return (
          <a
            key={index}
            href={service.url}
            className={`segment ${service.className}`}
            style={{
              top: `calc(50% + ${y}px)`,
              left: `calc(50% + ${x}px)`,
              transform: 'translate(-50%, -50%)'
            }}
          >
            <span className="segment-label">{service.label}</span>
            <span className="segment-learn">Dive Deeper→</span>

          </a>
        );
      })}
    </div>
  );
}